import { render, staticRenderFns } from "./photo_list.vue?vue&type=template&id=0d8fe0e3&scoped=true&"
import script from "./photo_list.vue?vue&type=script&lang=js&"
export * from "./photo_list.vue?vue&type=script&lang=js&"
import style0 from "./photo_list.vue?vue&type=style&index=0&id=0d8fe0e3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d8fe0e3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d8fe0e3')) {
      api.createRecord('0d8fe0e3', component.options)
    } else {
      api.reload('0d8fe0e3', component.options)
    }
    module.hot.accept("./photo_list.vue?vue&type=template&id=0d8fe0e3&scoped=true&", function () {
      api.rerender('0d8fe0e3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/sfa/views/reports/promote_employee_salaries/form/photo_list.vue"
export default component.exports